import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Utilities } from 'src/app/helpers/utilities';
import { List } from 'linqts';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { CdkDragStart, CdkDragMove, CdkDragDrop, moveItemInArray, copyArrayItem, transferArrayItem } from '@angular/cdk/drag-drop';
import { StaticData } from 'src/app/helpers/static-data';
import { Subject } from 'rxjs';
import { ConfigWindow } from 'src/app/models/config-window';
import { HelperImages } from 'src/app/helpers/helper-images';
import { GeneralComunicationService } from 'src/app/services/general-comunication.service';

@Component({
  selector: 'app-drag-and-dop-metadata',
  templateUrl: './drag-and-dop-metadata.component.html',
  styleUrls: ['./drag-and-dop-metadata.component.scss']
})

export class DragAndDopMetadataComponent implements OnInit, OnDestroy {

  @Output() onInitialized = new EventEmitter<any>();
  @Input() public parentClearCall: Subject<any>;
  @Input() public parentCallRefresh: Subject<any>;
  @Input() isModelContainer: boolean = false;
  @Output() onActionEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() config: any;
  @Input() QueryConfig: any;
  _modelo: any;
  @Input() set modelo(value: any) {
    this._modelo = value;
    if (this.isInit === true) {
      // setTimeout(() => {
      //  

      //   this.SetModelo(this._modelo);
      // }, 500);

    }
  }

  get modelo(): any {

    return this._modelo;

  }

  @Input() propConfiguracionInterna: string = 'Metadatos';
  @Input() propConfiguracion: string = 'Configuracion';
  @Input() componentName: string = 'DragAndDopMetadataComponent';
  @Input() name: string = 'DragAndDopMetadataComponent';
  @Input() url: string = '';
  @Input() processMessage: string = 'Cargando metadatos...';

  @Input() pkField: string = 'Id';
  @Input() textField: string = '';
  @Input() loadOnInit: boolean = true;
  @Input() listName: string = "drop-list-metadata";
  @Input() listToConnect: Array<any> = ['drop-list-form', 'drop-list-extra', 'drop-list-meta', 'drop-list-list', 'drop-list'];
  @Input() label: string = 'dsadsdsad';
  isInit: boolean = false;

  allSelectionItems: Array<any> = [];
  userControls: Array<any> = [];
  selectionItems: Array<any> = [];
  selectedItems: Array<any> = [];
  deltetedItems: Array<any> = [];
  addItems: Array<any> = [];

  Estilos: any;
  public direction: string = 'horizontal';
  public directionOrgCharts: string = 'vertical';
  public directionGrid: string = 'horizontal';
  EstiloBuscarContenedor: any = { height: "600px" };

  @Input() Hidden: boolean = false;
  @Input() Disabled: boolean = false;

  constructor(public baseService: BaseServiceService, public utility: Utilities, public helperImages: HelperImages, public comunicationService: GeneralComunicationService) { }

  //* FUNCIONES ANGULAR

  ngOnDestroy(): void {

    this.utility.Unsubscribe(this.parentClearCall);
    this.utility.Unsubscribe(this.parentCallRefresh);

  }

  ngOnInit() {

    debugger;
    this.Estilos = StaticData.Estilos;
    this.isInit = true;
    this.allSelectionItems = this.utility.Clone(StaticData.ToolBox.UserControls);
    this.selectionItems = this.utility.Clone(StaticData.ToolBox.UserControls);
    this.OnSetConfig();
    this.OnInit();

    if (this.parentClearCall){
      this.parentClearCall.subscribe(event => {
        this.InitControl(event);
      });

    }
    this.comunicationService.receivedFormEvent.subscribe(event => {
      if (event.Action == 'Edit') {
        this.InitControl(event);
      }
    });

    if (this.onInitialized.observers.length) {
      setTimeout(() => {

        this.onInitialized.emit(this);
      }, 1000);
    }

  }

  InitControl(event) {
    this.InitList();
    setTimeout(() => {
      this.modelo = event.modelo;
      this.SetModelo(event.modelo);
      this.ValidateSelectionItems();
    }, 100);
  }
  //* END FUNCIONES ANGULAR

  //* FUNCIONES PERSONALIZADAS

  public InitAll(modelo) {

    this.InitList();
    this.SetConfiguracion();
    this.SetModelo(modelo);

  }

  InitList() {

    this.selectedItems = [];
    this.deltetedItems = [];
    this.addItems = [];

  }

  OnInit() {

    this.SetConfiguracion();

    if (this.loadOnInit === true) {
      this.Load();
    }

  }

  public OnSetConfig() {

    this.listToConnect.push(this.listName);
    if (this.config) {
      this.label = this.config.Label || this.label;
      if (this.config.ConfigControl) {
        if (!this.url)
          this.url = this.config.ConfigControl.Controller;

        if (this.config.ConfigControl.QueryConfig && this.config.ConfigControl.QueryConfig.Command) {
          this.QueryConfig = this.config.ConfigControl.QueryConfig;

          if (this.config.ConfigControl.QueryConfigSelection && this.config.ConfigControl.QueryConfigSelection.ProcessMessage)
            this.processMessage = this.config.ConfigControl.QueryConfigSelection.ProcessMessage;
        }
      }
      if (this.config.ProcessMessage)
        this.processMessage = this.config.ProcessMessage;

      this.pkField = this.config.PkField || this.pkField;
      this.textField = this.config.TextField || this.textField;
      this.propConfiguracionInterna = this.config.ConfigInternalProp || this.propConfiguracionInterna;
      this.propConfiguracion = this.config.ConfigProp || this.propConfiguracion;
      this.name = this.config.Name || this.name;
    }

    if (!this.name)
      this.name = this.componentName;
    let _config = {
      "Controller": "",
      "ProcessMessage": "",
      "PkField": "Id",
      "ConfigInternalProp": "",
      "ConfigProp": "Configuracion",
      "ConfigControl": {
        "QueryConfig": { "Url": "", "ProcessMessage": "", "Command": "" },
        "QueryConfigSelection": { "Url": "", "ProcessMessage": "", "Command": "" }
      }
    };

  }

  _SetModelo(modelo: any) {

    let temp;
    this.selectedItems = [];

    if (this.propConfiguracionInterna) {
      if (typeof modelo[this.propConfiguracion] === 'string') {

        if (modelo[this.propConfiguracion].startsWith("[")) {

          StaticData.ShowActionNotificationError("Los Metadatos No Cumplen el Formato","Error Modelo",500);
         // this.utility.VerModalDanger({ titulo: "Error Modelo", descripcion: "Los metadatos estan mal formados" });
          return;
        }
        
        temp = (!modelo[this.propConfiguracion]) ? {} : JSON.parse(modelo[this.propConfiguracion]);
      }
      else {
        temp = (!modelo[this.propConfiguracion]) ? {} : modelo[this.propConfiguracion];
      }
      if (temp.hasOwnProperty(this.propConfiguracionInterna))
        this.selectedItems = temp[this.propConfiguracionInterna];
      else {
        this.selectedItems = [];
        temp[this.propConfiguracionInterna] = this.selectedItems;
      }
    }
    else {
      temp = JSON.parse(modelo[this.propConfiguracion]);
      this.selectedItems = temp;
    }

  }

  public SetModelo(modelo: any) {

    this._modelo = modelo;
    let temp;
    this.selectedItems = [];
    if (this.modelo) {
      if (this.isModelContainer)
        this._SetModelo(this.modelo.modelo);
      else
        this._SetModelo(this.modelo);
    }
    else {
      this.selectedItems = []
    }
    this.SetConfiguracion();

  }

  _SetConfiguracion(modelo: any) {

    if (this.propConfiguracionInterna) {
      let temp;
      if (typeof modelo[this.propConfiguracion] === 'string') {

        if (modelo[this.propConfiguracion].startsWith("[")) {

          StaticData.ShowActionNotificationError("Los Metadatos No Cumplen el Formato","Error Modelo",500);
         // this.utility.VerModalDanger({ titulo: "Error Modelo", descripcion: "Los metadatos estan mal formados" });
          return;
        }

        temp = (!modelo[this.propConfiguracion]) ? {} : JSON.parse(modelo[this.propConfiguracion]);
      }
      else {
        temp = (!modelo[this.propConfiguracion]) ? {} : modelo[this.propConfiguracion];
      }


      temp[this.propConfiguracionInterna] = this.selectedItems;
      modelo[this.propConfiguracion] = JSON.stringify(temp);
    }
    else {
      modelo[this.propConfiguracion] = JSON.stringify(this.selectedItems);
    }

  }

  public SetConfiguracion() {

    if (this.modelo) {
      if (this.isModelContainer)
        this._SetConfiguracion(this.modelo.modelo);
      else
        this._SetConfiguracion(this.modelo);
    }

  }

  public ValidateSelectionItems() {

    this.selectionItems = this.utility.Clone(this.allSelectionItems);
    this.selectedItems.forEach((item, index) => {
      let currentIndex = this.selectionItems.findIndex(x => { return x[this.pkField] == item[this.pkField]; })
      if (currentIndex > -1) {
        this.selectionItems.splice(currentIndex, 1);
      }
      else {
        // this.selectionItems.push(item);
      }
    })

  }

  RemoveItem(item: any, items: Array<any>) {

    if (this.Disabled)
      return;
    let currentIndex = items.findIndex(x => { return x[this.pkField] == item[this.pkField]; })
    if (currentIndex > -1) {
      items.splice(currentIndex, 1);
    }

  }

  EndAction(item: any, items: Array<any>, actionType: string) {

    this.RemoveItem(item, items);
    this.ValidateSelectionItems();
    this.SetConfiguracion();
    this.FireAction(actionType);

  }

  public Add(item, index) {
    if (this.Disabled)
      return;
    //let newItem: any = { Name: item.Name, Id: item.Id, ControlType: item.ControlType,Label: item.Label };
    this.selectedItems.push(item);
    this.addItems.push(item);
    this.EndAction(item, this.deltetedItems, 'Add');

  }

  selectField(event: any) {
    if (this.Disabled)
      return;

    this.internalsSelectField({ control: null, index: 0 });
    setTimeout(() => {
      this.internalsSelectField(event);
    }, 50);

  }

  internalsSelectField(event: any) {

    if (event.control && event.control.ControlType == 'GridView') {
      // if (!event.control.Columns)
      //   event.control.Columns = [];
      if (!event.control.ConfigControl)
        event.control.ConfigControl = {
          "Controller": "",
          "Params": {},
          "QueryConfig": {
            "Command": "",
            "IsSp": false,
            "Entity": {},
            "WithPagination": false,
            "OutPutParam": false,
          },
          "NotLoad": false
        };
    }
    this.currentFieldModel = event.control;// this.model.Controls[event.index];
    this.currentIndexFieldModel = event.index;

    if (event.isWindow) {
      this.verProperty(event.index);
    }

  }

  currentIndexFieldModel: any = null;
  currentFieldModel: any = 0;
  verProperty(index): any {
    let config: ConfigWindow = new ConfigWindow();
    config.classWindow = 'info';
    config.titleWindow = "Propiedades";
    config.returnInstance = false;
    config.modal = false;
    config.width = 600;
    config.height = 600;
    config.viewOk = false;
    config.cancel = 'Cerrar';
    let windowModel: any = {
      subControl: this.currentFieldModel,
      subControlIndex: this.currentIndexFieldModel,
      isMetadata: true
    };
    this.utility.OpenWindow('PropertyGridControlsComponent',
      config, windowModel).then(dataResult => {
        // console.log(dataResult);
        dataResult.onClosePromise.then(dataResultOnClose => {
          // console.log(dataResultOnClose);
        });
      })
  }

  public Delete(event) {
    if (this.Disabled)
      return;
    this.selectedItems.splice(event.index, 1);
    this.deltetedItems.push(event.control);
    this.EndAction(event.control, this.addItems, 'Delete');

  }

  FireAction(actionType: string) {

    this.onActionEventEmitter.emit({
      modelo: this.modelo,
      deltetedItems: this.deltetedItems,
      selectedItems: this.selectedItems,
      addItems: this.addItems,
      type: this.name,
      componentName: this.componentName,
      actionType: actionType,
    });

  }

  public Load() {

    try {
      if (this.QueryConfig && this.QueryConfig.Command) {
        let obj = this.utility.GetApiModel('Load', '');
        obj.QueryConfig = this.QueryConfig;
        const _url = (this.QueryConfig.Url) ? this.QueryConfig.Url : this.url;
        this.baseService.Get(obj, null,
          {
            componentName: this.componentName,
            processMessage: this.processMessage,
            method: 'Load'
          }, _url, false, true).then(result => {
            this.allSelectionItems = result.Data;;
            this.ValidateSelectionItems();
          }).catch(error => {
            this.utility.logger.LogError(error, obj, { componentName: this.componentName, method: 'Load' });
          })
      }
      else {
        this.allSelectionItems = this.utility.Clone(StaticData.ToolBox.UserControls);
        this.ValidateSelectionItems();
      }
    }
    catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: 'Load' });
      this.utility.VerModalDanger().then(data => { });
    }

  }

  //! NO HACE NADA
  dragStart(event: CdkDragStart) {
    // this._currentIndex = this.fieldModels.indexOf(event.source.data); // Get index of dragged type
    // this._currentField = this.child.nativeElement.children[this._currentIndex]; // Store HTML field
  }

  //! NO HACE NADA
  moved(event: CdkDragMove) {
    // Check if stored HTML field is as same as current field
    // if (this.child.nativeElement.children[this._currentIndex] !== this._currentField) {
    //   // Replace current field, basically replaces placeholder with old HTML content
    //   // this.child.nativeElement.replaceChild(this._currentField, this.child.nativeElement.children[this._currentIndex]);
    // }
  }

  itemDropped(event: CdkDragDrop<any[]>) {
    if (this.Disabled)
      return;
    if (event.previousContainer === event.container) {
      moveItemInArray(this.selectedItems, event.previousIndex, event.currentIndex);
    } else {
      this.Add(event.item.data, event.currentIndex);
    }

  }

  //* END FUNCIONES PERSONALIZADAS

}
